import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { formatRequestNumber as formatTransactionNumber } from "fe-shared-requests/src/helpers/format";

import styles from "./RequestLinkedTransaction.module.scss";

interface Props {
  transactionNumber?: string | null;
  isHauler: boolean;
  canOpenTransaction: boolean;
}

const RequestLinkedTransaction = ({
  transactionNumber,
  isHauler,
  canOpenTransaction,
}: Props) => {
  const { t } = useTranslation();

  if (!transactionNumber) {
    return null;
  }

  const label = t(
    isHauler
      ? "pickupRequests.details.linkedPickup"
      : "pickupRequests.details.linkedShipment"
  );
  const number = formatTransactionNumber(transactionNumber);

  const text = `${label} ${number}`;

  return (
    <div className={styles.row}>
      {isHauler && canOpenTransaction ? (
        <Link
          className={`${styles.text} ${styles.link}`}
          to={`/transactions/${transactionNumber}`}
        >
          {text}
        </Link>
      ) : (
        <span className={styles.text}>{text}</span>
      )}
    </div>
  );
};

export default RequestLinkedTransaction;
